const endpoints = {
  navbar: '/arsh-portfolio/profile/navbar.json',
  routes: '/arsh-portfolio/profile/routes.json',
  home: '/arsh-portfolio/profile/home.json',
  social: '/arsh-portfolio/profile/social.json',
  about: '/arsh-portfolio/profile/about.json',
  skills: '/arsh-portfolio/profile/skills.json',
  education: '/arsh-portfolio/profile/education.json',
  experiences: '/arsh-portfolio/profile/experiences.json',
  projects: '/arsh-portfolio/profile/projects.json',
};

export default endpoints;
